import * as React from "react";

import "./product-options-section.scss";

import {cs}       from "@Common/react/chain-services";
import {keyed}    from "@Common/react/keyed";
import {UseState} from "@Common/react/use-state";

export const ProductOptionsSection = ({showErrors, itemOptionsStates}) => cs(
    ["sections", (_, next) => next([
        {
            name: "paperType",
            render: (ui) => ui,
        },
        {
            name: "pdfDownload",
            render: (ui) => ui,
        },
        {
            name: "lineItems",
            render: (ui) => ui,
        },
    ]
        .filter((section) => itemOptionsStates[section.name])
    )],
    ({sections}, next) => sections.length ? next() : null,
    ["show", (_, next) => UseState({
        initValue: true,
        next,
    })],
    ({show, sections}) => (
        <div className="product-options-section-6hs">
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name="Product Options">
                    Product Options
                </div>
                <div className="action">
                    <a xd-qa-type="link" xd-qa-name="Show/Hide" onClick={() => show.change(v=>!v)}>{show.value ? "Hide" : "Show"}</a>
                </div>
            </div>

            {show.value && (
                <div className="sections">
                    {sections
                        .map((section) => cs(
                            keyed(section.name),
                            ["state", (_, next) => next(itemOptionsStates[section.name])],
                            ({state}) => section.render(state)
                        ))
                    }
                </div>
            )}
        </div>
    )
);
